module.exports = __webpack_public_path__ + "static/media/restroom.2c9bcbf3.svg";